var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromoDiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 276,
    viewBox: "0 0 346 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_118_47",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 346,
    height: 276
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 346,
    height: 276,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_118_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.112 169.289L173.289 208.652L131.445 177.615L97.3386 230.963L130.226 223.071L186.048 254.781L221.168 197.605",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.467 185.448L247.501 227.711L267.431 287.698L310.685 245.811L287.584 248.401L280.227 211.111L245.017 170.59",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.698 57.9376L157.239 45.369L134.964 115.042L147.55 116.478L140.353 168.129L235.831 180.636L272.936 173.501L287.99 72.9597L256.698 57.9376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.207 116.171L230.919 124.72L249.928 63.9818",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoDiscountIcon);
export default __webpack_public_path__ + "static/media/promo-discount-icon.3d717834a36035a300c48c60529139f2.svg";
export { ForwardRef as ReactComponent };